import { PopularityItem } from 'common/types/entities/mongo/popularity'
import { getVerticalBySubVertical, SubVertical } from 'common/constants'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export const fetchPopularityCategories = async (
  subVertical: SubVertical,
  menuId?: string,
  headers?: any,
): Promise<PopularityItem[]> => {
  const vertical = getVerticalBySubVertical(subVertical)
  const result = await axios.get<PopularityItem[]>(`/v1/popular/${vertical}/${subVertical}/categories`, {
    ...getHeaders(headers),
    params: { menuId },
  })
  return result && result.data
}

export const fetchPopularityBrands = async (subVertical: SubVertical, menuId?: string): Promise<PopularityItem[]> => {
  const vertical = getVerticalBySubVertical(subVertical)
  const result = await axios.get<PopularityItem[]>(`/v1/popular/${vertical}/${subVertical}/brands`, {
    params: { menuId },
  })
  return result && result.data
}

export const fetchPopularityTags = async (
  subVertical: SubVertical,
  menuId?: string,
  headers?: any,
): Promise<PopularityItem[]> => {
  const vertical = getVerticalBySubVertical(subVertical)
  const result = await axios.get<PopularityItem[]>(`/v1/popular/${vertical}/${subVertical}/tags`, {
    ...getHeaders(headers),
    params: { menuId },
  })
  return result && result.data
}
